<template>
  <div class="tab-bar-item" @click="itemclick">
    <div v-if="isactive">
      <slot name="item-img"></slot>
    </div>
    <div v-else>
      <slot name="item-img-active"></slot>
    </div>

    <div :style="activestyle">
      <slot name="item-text"></slot>
    </div>
  </div>
</template>

<script>
import {
  judgeActivePage,
  publicFadeInOut,
  jieMianStateJudge
} from 'common/tool'
export default {
  data() {
    return {
      // isactive:false
    }
  },
  props: {
    path: {
      type: String,
      default: 'nullpath'
    },
    activecolor: {
      type: String,
      default: 'var(--primary-color)' //用户没有传颜色时用默认的
    }
  },
  computed: {
    isactive() {
      ////比较当前点击的活跃对象的路径与 对象本身的路径是否想相同来确定 哪一个处于活跃状态
      return this.$route.path.indexOf(this.path) !== -1
    },
    activestyle() {
      ///动态绑定活跃文字的样式，如果处于活跃的，就把用户传来了颜色就用用户传来的，
      return this.isactive ? { color: this.activecolor } : {}
    }
  },
  methods: {
    itemclick() {
      // console.log('itemclick')
      // console.log(this.path)
      console.log('tab-bar-item被点击了')

      if (this.$store.state.configinfo.objectMoveState) {
        ////说明当前是界面管理状态
        if (!jieMianStateJudge()) return ///界面管理状态判断
        return
      }
      if (this.path === 'nullpath') return
      this.$router.replace(this.path)
    }
  }
}
</script>

<style>
.tab-bar-item {
  flex: 1;
  text-align: center;
  height: 64px;
  font-size: 18px;
  color: #666;
}

.tab-bar-item img {
  width: 34px;
  height: 34px;
  margin-top: 3px;
  vertical-align: middle;
  margin-bottom: 1px;
}
</style>
